import messages from '../../../locale/messages'
import { inputDescLimit, inputTextLimit } from '../../../helpers/fieldRestriction';

const validate = values => {

  const errors = {}

  if (!values.reason) {
    errors.reason = messages.reasonRequired;
  } else if (values.reason.trim() == "") {
    errors.reason = messages.reasonRequired
  } else if (values.reason.length > inputDescLimit) {
      errors.reason = messages.inputDescLimitError
  }

  return errors
}

export default validate
